<template>
  <div>
    <div title="Add to basket" class="crossell-item flex-column" @click.stop="handleClickAction(item, 'add')">
      <div class="product__image">
        <TheMagazineImage :item="item" :show-save-overlay="false" :show-free-gift-overlay="false" />
      </div>
      <div class="product__information">
        <div class="product__title">{{ item.offer_title }}</div>
        <div class="product__offer">
          <p class="product__price">Price {{ formatCurrency(item.offer_price) }}</p>
        </div>
        <div class="actions">
          <div class="add-to-basket">Add to basket</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formatCurrency } from '~/lib/util/basket'
import { getGA4EcommerceNullPayload, getGA4EcommerceBasketActionPayload } from '~/lib/util/gtmGA4'
import { sendSSAPIAddToCart, createUniqueFBEventId } from '~/lib/util/fb'
import basketMixin from '~/mixins/basket.vue'
import baseProductMixin from '~/mixins/baseProduct.vue'

export default {
  name: 'CheckoutCartCrossSellProduct',
  serverCacheKey() {
    return false
  },
  components: {
    TheMagazineImage: () => import('~/components/common/TheMagazineImage')
  },
  mixins: [basketMixin, baseProductMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imageSrcQS: '?fm=png&auto=format&fit=fill&fill=solid&bg=0FFF&w=106'
    }
  },
  methods: {
    formatCurrency(value) {
      return formatCurrency(value)
    },
    async handleClickAction(item, action) {
      this.$nuxt.$emit('TOGGLE_LOADING', true)
      console.log(
        `CHECKOUT_CART/CROSS_SELL handleClickAction action=${action} basket.id=${this.$store.state.basket.id} product_sku=${item.product_sku} item.offer_sku=${item.offer_sku}`
      )

      // Map the item to IBasketItemRequest
      const i = {
        ...item,
        id: item.offer_id,
        sku: item.product_sku,
        offer: {
          ...item,
          id: item.offer_id,
          sku: item.offer_sku
        }
      }
      // Update the BE Basket data
      const ret = await this.updateBasket({ item: i, action, type: item.type, source: 'CROSS_SELL', sourceVersion: this.$config.DefaultVersion })

      if (ret.error) {
        // Error, show an overlay on the page
        this.$nuxt.$emit('SHOW_NOTIFICATION', { data: ret.error, show: true })
      } else {
        // Facebook Event Deduplication
        let eventId
        switch (action) {
          case 'add':
            eventId = createUniqueFBEventId('AddToCart')
            break
          case 'remove':
          case 'delete':
            eventId = createUniqueFBEventId('RemoveFromCart')
            break
          default:
            break
        }
        // Customer email address
        const email = this.$store.getters['s/email']

        // GA4 events for each Basket Button's Click
        this.$config.GA4Syntax && this.$config.GA4FireEcommerceNull && this.$gtm && this.$gtm.push(getGA4EcommerceNullPayload())
        this.$config.GA4Syntax && this.$gtm && this.$gtm.push(getGA4EcommerceBasketActionPayload({ action, item: i, eventId, email }))

        if (action === 'add') {
          // FB v12.0
          const eventSourceUrl = `${this.$config.baseURL}${this.$route.fullPath}`
          // Facebook Server-side API AddToCart
          sendSSAPIAddToCart({ context: this, item: i, parameters: { eventId, eventSourceUrl } })
        }
      }
      this.$nuxt.$emit('TOGGLE_LOADING', false)
      return false
    }
  }
}
</script>
<style lang="scss">
.actions {
  &:hover {
    cursor: pointer;
  }
}
.flex-column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-items: flex-start;
  margin: 0.1em 0.1em 1.25em;
}
.crossell-item {
  flex: 1 0 18.5%;
  max-width: 170px;
  min-width: 100px;
  padding: 10px 20px 0px 20px;
  &:hover {
    background-color: #ededed;
    text-decoration: none;
    cursor: pointer;
    .add-to-basket {
      text-decoration: none;
    }
  }
}
.product {
  &__information {
    padding: 0.5em 0.1em 0.1em;
    text-align: center;
  }
  &__title {
    font-weight: 700;
    color: #333;
    font-size: 12px;
    min-height: 34px;
    overflow: hidden;
    padding-bottom: 5px;
    text-overflow: ellipsis;
    text-transform: uppercase;
    vertical-align: middle;
  }
  &__price {
    color: #b30d00;
    font-size: 12px;
    line-height: 12px;
    margin: 0;
    font-weight: 700;
  }
}
.add-to-basket {
  color: #00933e;
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  margin: 0;
  min-width: 100px;
  padding: 15px 0;
  text-align: center;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
}
</style>
